import { render, staticRenderFns } from "./DefaultBanners.vue?vue&type=template&id=bf3cb3d8"
import script from "./DefaultBanners.vue?vue&type=script&lang=ts"
export * from "./DefaultBanners.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports